import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiRoutes} from '../../config/api-routes';
import {Observable} from 'rxjs';
import {LoginResponse} from '../shared/model/login-response';
import { ApplicationErrorCode } from '../shared/enums/application-error-code';

@Injectable()
export class LoginService {
  constructor(private httpClient: HttpClient, private apiRoutes: ApiRoutes) {}

  public login(username: string, password: string): Observable<LoginResponse> {
    // return of({code: ApplicationErrorCode.OK,
    //   refreshToken: "08A4C585008C67B8DF11D34855FD0844",
    //   token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbklkIjoiNzQiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9lbWFpbGFkZHJlc3MiOiJtYXJlay5jYWx1c0BqaXQudGVhbSIsIkZpcnN0TmFtZSI6Im0iLCJMYXN0TmFtZSI6ImMiLCJDdWx0dXJlIjoiZW4iLCJleHAiOjE1Nzk1MDYwNTksImlzcyI6ImNoYXBwcy5jb20iLCJhdWQiOiJjaGFwcHMuY29tIn0.LSJ3cPBQdwH3COB0XSpuAyGvqUi0rfRVOw0SbY024ZY"})
    return this.httpClient.post<LoginResponse>(this.apiRoutes.LOGIN, { username, password });
  }
}
